import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  /* -------------- 车辆预约 -------------- */
  {
    path: '/reservation',
    name: 'Reservation',
    component: Main,
    meta: {
      disabled: true,
      label: '车辆预约',
    },
    children: [
      {
        name: 'LetterReservationList',
        component: () => import('@/views/Reservation/LetterReservation/reservationList'),
        path: 'letterReservationList',
        meta: {
          label: '函件预约申请',
        },
      },
      {
        name: 'LetterReservationListParent',
        path: 'letterReservationListParent',
        redirect: {name: 'LetterReservationList'},
        component: ParentView,
        meta: {
          label: '函件预约申请',
        },
        children: [
         /* {
            name: 'reservationDetails',
            path: 'reservationDetails',
            component: () => import(/!* webpackChunkName: "reservation" *!/ '@/views/Reservation/LetterReservation/letterReservation'),
            props: true,
            meta: {
              label: '预约详情',
              subText: 'query.obGrpName',
              cacheKey: 'query.id',
            },
          },*/
          {
            name: 'visitorList',
            path: 'visitorList',
            components: {
              default: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/LetterReservation/visitorList'),
              children: ParentView
            },
            props: true,
            meta: {
              label: '批量预约车辆管理',
              subText: '',
              cacheKey: 'query.id',
            },
          }
        ],
      },
      {
        name: 'reservationDetails',
        path: 'reservationDetails',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/LetterReservation/letterReservation'),
        props: true,
        meta: {
          label: '预约详情',
          subText: 'query.obGrpName',
          cacheKey: 'query.id',
        }
      },
      {
        name: 'LetterReservationReview',
        component: () => import('@/views/Reservation/LetterReservation/reservationList-review'),
        path: 'letterReservationReview',
        meta: {
          label: '函件预约管理',
        },
      },
      {
        name: 'LetterReservationReviewParent',
        path: 'letterReservationReviewParent',
        redirect: {name: 'LetterReservationReview'},
        component: ParentView,
        meta: {
          label: '函件预约管理',
        },
        children: [
         /* {
            name: 'reservationDetails',
            path: 'reservationDetails',
            component: () => import(/!* webpackChunkName: "reservation" *!/ '@/views/Reservation/LetterReservation/letterReservation'),
            props: true,
            meta: {
              label: '预约详情',
              subText: 'query.obGrpName',
              cacheKey: 'query.id',
            }
          },*/
          {
            name: 'visitorList',
            path: 'visitorList',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/LetterReservation/visitorList'),
            props: true,
            meta: {
              label: '批量预约车辆管理',
              subText: '',
              cacheKey: 'query.id',
            },
          },
          {
            name: 'selfSignListBox',
            path: 'selfSignListBox',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/LetterReservation/selfSignListBox'),
            props: true,
            meta: {
              label: '自助登记车辆管理',
              subText: 'query.name',
            },
          }
        ]
      },
      /*{
        name: 'ReservationGroupList',
        path: 'admin/group',
        meta: {
          label: '高级预约',
        },
        props: true,
        component: () => import(/!* webpackChunkName: "reservation" *!/ '@/views/Reservation/Group/list'),
      },*/
      {
        name: 'AdminReservationParent',
        path: 'admin',
        redirect: {name: 'ReservationGroupList'},
        meta: {
          label: '高级预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'NewGroupReservation',
            path: 'new',
            meta: {
              label: '新建高级预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Admin/new'),
          },
          {
            name: 'AdminReservationDetails',
            path: ':plate/readonly',
            meta: {
              label: '预约详情',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Admin/details'),
          },
          {
            name: 'EditAdminReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Admin/edit'),
          },
        ],
      },
      {
        name: 'OrgReservation',
        path: 'organization',
        meta: {
          label: '单位预约',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Org/list'),
      },
      {
        name: 'OrgReservationParent',
        path: 'organization',
        redirect: {name: 'OrgReservation'},
        meta: {
          label: '单位预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'NewOrgReservation',
            path: 'new',
            meta: {
              label: '新建单位预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Org/new'),
          },
          {
            name: 'OrgReservationDetails',
            path: ':plate/readonly',
            meta: {
              label: '预约详情',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Org/details'),
          },
          {
            name: 'EditOrgReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Org/edit'),
          },
        ],
      },
      {
        name: 'PersonalReservation',
        path: 'personal',
        meta: {
          label: '个人预约',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Personal/list'),
      },
      {
        name: 'PersonalReservationParent',
        path: 'personal',
        redirect: {name: 'PersonalReservation'},
        meta: {
          label: '个人预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'NewPersonalReservation',
            path: 'new',
            meta: {
              label: '新建个人预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Personal/new'),
          },
          {
            name: 'PersonalReservationDetails',
            path: ':plate/readonly',
            meta: {
              label: '预约详情',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Personal/details'),
          },
          {
            name: 'EditPersonalReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Personal/edit'),
          },
        ],
      },
      {
        name: 'ReservationGroupList',
        path: 'admin/group',
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Group/list'),
        meta: {
          label: '高级预约',
        },
      },
      {
        name: 'ReservationGroupParent',
        path: 'admin/group',
        redirect: {name: 'ReservationGroupParent'},
        component: ParentView,
        props: true,
        meta: {
          label: '高级预约管理',
        },
        children: [
          {
            name: 'NewReservationGroup',
            path: 'new',
            meta: {
              label: '新建高级预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Group/new'),
          },
          {
            name: 'ReservationGroupDetails',
            path: ':id/readonly',
            meta: {
              label: '预约分组',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Group/details'),
          },
          {
            name: 'addVehicle',
            path: 'addVehicle',
            meta: {
              label: '添加车辆',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Admin/new'),
          },
          {
            name: 'EditReservationGroup',
            path: ':id/edit',
            meta: {
              label: '编辑预约分组',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Group/edit'),
          },
        ]
      },
      {
        name: 'groupReservationConfig',
        path: 'config/groupReservation',
        meta: {
          label: '高级预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Group/groupReservation'),
      },
      {
        name: 'letterReservationConfig',
        path: 'config/letterReservation',
        meta: {
          label: '函件预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/LetterReservation/letterReservation'),
      },
      {
        name: 'OrgReservationConfig',
        path: 'config/organization',
        meta: {
          label: '单位预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Org/orgReservation'),
      },
      {
        name: 'GroupConfigList',
        path: 'config/GroupConfigList',
        meta: {
          label: '单位配置列表',
          disabled: true,
          hideInBread: true,
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'NewGroupConfig',
            path: 'newGroupConfig',
            meta: {
              label: '新增预约单位配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Common/commonConfig_org'),
          },
        ],
      },
      {
        name: 'ConfigDetail',
        path: 'ConfigDetail',
        meta: {
          label: '配置详情',
        },
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Common/commonConfigBox'),
      },
      {
        name: 'PersonalReservationConfig',
        path: 'config/personal',
        meta: {
          label: '个人预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Personal/personalReservation'),
      },
      {
        name: 'PersonalConfigList',
        path: 'config/personalConfigList',
        redirect: {name: 'PersonalReservationConfig'},
        meta: {
          label: '个人配置列表',
          disabled: true,
          hideInBread: true,
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'NewPersonalConfig',
            path: 'newPersonalConfig',
            meta: {
              label: '新建预约个人配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Common/commonConfig_personal'),
          },
          {
            name: 'NewPersonalGroupConfig',
            path: 'newPersonalGroupConfig',
            meta: {
              label: '新建预约分组配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/Common/commonConfig_group'),
          },
        ],
      },
      {
        name: 'searchReservationConfig',
        path: 'config/searchConfig',
        meta: {
          label: '查询用户预约配置',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/searchReservationConfig'),
      },
      {
        name: 'VehicleSelfServiceReservationConfig',
        path: 'config/selfService',
        meta: {
          label: '自助预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation/Config/SelfService'),
      },
    ],
  },
  /* -------------- 函件预约自助登记页面 ----------- */
  {
    path: '/letterReservation/selfSign',
    name: 'selfSign',
    component: () => import( '@/views/Reservation/LetterReservation/selfSign'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  /* -------------- 高级预约自助登记页面 ----------- */
  {
    path: '/adminReservation/selfSign',
    name: 'adminSelfSign',
    component: () => import('@/views/Reservation/Group/selfSign'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  /* -------------- 人行高级预约自助登记页面 ----------- */
  {
    path: '/personAdminReservation/selfSign',
    name: 'personAdminSelfSign',
    component: () => import('@/views/PersonReservation/Group/selfSign'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
]
